//表头不能固定因为可能会进行变动
export const edihistory = [{
		name: '客户编码',
		Display: '客户编码',
		type: 1
	},
	{
		name: '物料编码',
		Display: '物料编码',
		type: 1
	},
	{
		name: '开始时间_from',
		Display: '开始时间从',
		type: 3
	},
	{
		name: '开始时间_to',
		Display: '开始时间止',
		type: 3
	}
]
export const edidiff = [{
		name: '订单编号',
		Display: '订单编号',
		type: 1
	},
	{
		name: '客户编号',
		Display: '客户编号',
		type: 1
	},
	{
		name: '版本号',
		Display: '版本号',
		type: 1
	},
	{
		name: '开始时间_from',
		Display: '开始时间从',
		type: 3
	},
	{
		name: '开始时间_to',
		Display: '开始时间止',
		type: 3
	}
]
export const logg = [{
		name: '操作码',
		Display: '操作码',
		type: 1
	},
	{
		name: '时间_from',
		Display: '时间起',
		type: 3
	},
	{
		name: '时间_to',
		Display: '时间止',
		type: 3
	},
	{
		name: '辅助数据',
		Display: '辅助数据',
		type: 1
	},
]
export const asnLog = [{
		name: '操作码',
		Display: '操作码',
		type: 1
	},
	{
		name: '模块',
		Display: '模块',
		type: 1
	},
	{
		name: '时间_from',
		Display: '时间起',
		type: 3
	},
	{
		name: '时间_to',
		Display: '时间止',
		type: 3
	},
	{
		name: '日志',
		Display: '日志',
		type: 1
	},
	{
		name: '辅助数据',
		Display: '辅助数据',
		type: 1
	},
]
